import { gql } from '@apollo/client';

/**
 * Get unified feed with cursor-based pagination
 * 
 * Combines all post types (PSA, Lost, Found, Pet Services) and NASA emergency alerts
 * into a single paginated feed sorted by date.
 */
export const GET_FEED = gql`
  query GetFeed(
    $userLocation: [Float!]!
    $radiusInKm: Float!
    $filter: FeedFilter
    $cursor: String
    $limit: Int
  ) {
    getFeed(
      userLocation: $userLocation
      radiusInKm: $radiusInKm
      filter: $filter
      cursor: $cursor
      limit: $limit
    ) {
      items {
        _id
        type
        title
        description
        createdAt
        updatedAt
        location {
          type
          coordinates
        }
        locationName
        userId

        # Pet Service image
        imageUrl

        # Lost/Found Animal fields
        animalName
        animalType
        animalImageUrl
        breed
        colorMarkings
        sex
        estimatedWeight
        reunited
        
        # Lost-specific
        dateLost
        lastSeen
        rewardAmount
        approachable
        
        # Found-specific
        dateFound
        foundNear
        
        # Contact info
        contactName
        contactPhone
        contactEmail

        # Emergency (NASA) fields
        nasaEventId
        categories {
          id
          title
        }
        sources {
          id
          url
        }
        expiresAt
        extensionCount
        lastExtendedAt
      }
      pageInfo {
        nextCursor
        hasMore
      }
      counts {
        total
        lost
        found
        psa
        petService
        emergency
      }
    }
  }
`;

